/**
 * P2A Social Share Widget
 *
 * The widget is initialized by evaluating the attributes
 * on any DOM element, which has an attribute of [data-p2a-social-share]
 * Other attributes define what should be written into
 * the element, and how the intent URLs should be composed
 *
 * Full Example:
 * 	<div
 * 		  data-p2a-social-share
 * 	    data-customer-id="123"
 * 		  data-facebook="false"
 * 		  data-facebook-auth="true"
 * 		  data-twitter="true"
 * 	    data-twitter-auth="true"
 * 	    data-subdomain="mysub"
 * 		  data-domain="p2a.co"
 * 		  data-shorturl="abc123"
 * 	    data-longurl="https://p2a.co/abc123"
 * 	    data-lang="ES"
 * 		  data-style="rounded small clear"
 * 	></div>
 *
 * In order for initialization to occur, the element must
 * have a domain, shorturl, and at least one network
 */

module.exports = (function() {

    let SocialShareModule = function ($el) {

        let self = this;

        self.$el = $el;

        /**
         * @param boolean unencode Return the
         * @return string
         */
        self.shareUrlParams = function (unencode) {

            let amp = (unencode === true) ? '&' : '&amp;';

            return 'url=' + self.params.get('shorturl') +
                amp + 'domain=' + self.params.get('domain') +
                amp + 'subdomain=' + self.params.get('subdomain') +
                amp + 'longurl=' + self.params.get('longurl');
        };

        /**
         * Build the markup for the share elements, and
         * inject into our parent element
         *
         * @return void
         */
        self.injectMarkup = function () {

            let markup = '';

            // share label
            markup += '<span class="p2a-social-share-label">';
            if (self.params.get('lang') === 'ES') {
                markup += 'Comparte Con Los Demás';
            } else {
                markup += 'Share With Others';
            }
            markup += '</span>';

            markup += '<div class="p2a-social-share-networks">';

            // el to display error message if any error occurs
            markup += '<div class="alert alert-danger" id="social-err"></div>';

            if (self.params.checkFor('twitter')) {
                markup += self.buildAnchor('twitter', self.params.checkFor('twitter-auth'));
            }

            if (self.params.checkFor('facebook')) {
                markup += self.buildAnchor('facebook', self.params.checkFor('facebook-auth'));
            }

            markup += '</div>';

            let $markup = $(markup);

            let style = self.params.gridClass();

            if (self.params.has('style')) {
                style += ' ' + self.params.get('style');
            }

            self.$el.addClass(style);

            // populate the target element
            self.$el.addClass('p2a-social-share').html($markup);
        };

        /**
         * @param url string
         * @param windowName string If not present, a random name will be generated
         * @return object promise
         */
        self.popupWindow = function (url, windowName) {

            let $deferred = $.Deferred(),
                width = 800,
                height = 600,
                left = parseInt((window.width - width) / 2),
                top = parseInt((window.height - height) / 3);

            if (!windowName) {
                windowName = 'window-' + Math.random(1000);
            }

            let windowRef = window.open(
                url,
                windowName,
                'menubar=0,location=0,status=0,width=' + width + ',height=' + height + ',resizable=1,left=' + left + ',top=' + top
            );

            // poll for when the window is closed
            let checkInterval = setInterval(function () {
                if (windowRef && windowRef.closed) {
                    clearInterval(checkInterval);
                    $deferred.resolve(windowRef);
                }
            }, 500);

            return $deferred;
        };

        /**
         * Build the anchor element to be injected
         * @param network string twitter|facebook
         * @param isAuthShare boolean
         * @return string
         */
        self.buildAnchor = function (network, isAuthShare) {
            let uri = `/share/${network}`;
            let popupAttribute = '';
            const networkName = network.replace(/\b./g, function(m){ return m.toUpperCase(); });
            if (isAuthShare === true) {
                uri += '/authorize';
                popupAttribute = 'data-oauth-popup';
            }

            return `<a href="${uri}?${self.shareUrlParams()}" class="${network}" ${popupAttribute} target="_blank" title="Share on ${networkName}" aria-label="Share on ${networkName}"><i class="fa fa-${network}"></i></a>`;
        };

        /**
         * Hijack a click event to do something instead of link to URL
         *
         * @param target string The share type/network, which will
         * correspond to the class assigned to the linked element
         * @param tocall function The function to execute instead of
         * the standard link event
         */
        self.registerClickEvent = function (target, tocall) {
            self.$el.off('click', '.' + target).on('click', '.' + target, function (e) {
                e.preventDefault();
                tocall.call(this, e);
            });
        };

        /**
         * @param msg string
         * @return void
         */
        self.showError = function (msg) {
            self.$el.find('#social-err').html(msg).show();
        };

        /**
         * @return void
         */
        self.clearError = function () {
            self.$el.find('#social-err').html('').hide();
        };

        /* ================= NETWORK-SPECIFIC FUNCTIONS ==== */


        /* ================= PARAM FUNCTIONS ==== */

        self.params = {};

        /**
         * @returns {boolean}
         */
        self.params.has = function (param) {
            return typeof self.$el.data(param) !== 'undefined';
        };

        /**
         * @returns {string|null}
         */
        self.params.get = function (param) {
            if (self.params.has(param)) {
                return self.$el.data(param);
            } else {
                return null;
            }
        };

        /**
         * @param param string
         * @returns {boolean}
         */
        self.params.checkFor = function (param) {
            return self.params.get(param) === true || self.params.get(param) === 'true';
        };

        /**
         * @returns {boolean}
         */
        self.params.hasRequiredParams = function () {
            return self.$el.length &&
                (self.params.checkFor('facebook') || self.params.checkFor('twitter')) &&
                (self.params.get('domain') || self.params.get('shorturl'));
        };

        /**
         * @returns {string}
         */
        self.params.gridClass = function () {

            let cnt = 0,
                classes = {2: 'halves', 3: 'thirds', 4: 'fourths'};

            $.each(['facebook', 'twitter'], function (k, opt) {
                if (self.params.checkFor(opt)) {
                    cnt++;
                }
            });

            return classes[cnt] || '';
        };
    };

    /* INIT */

  $(function() {
    $.each($('[data-p2a-social-share]'), function (i, el) {

        let SocialShare = new SocialShareModule($(el));

        if (!SocialShare.params.hasRequiredParams()) {
            return;
        }

        SocialShare.injectMarkup();

        // open popups in new window
        $('[data-oauth-popup]').unbind('click.oauthPopup').on('click.oauthPopup', function(e) {
            e.preventDefault();
            SocialShare.popupWindow($(this).attr('href'));
        });
    });
  });

})();
